// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__yHp6J","modalInner":"style_modalInner__I0C6_","contact":"style_contact__7ATdb"};